import { Button, DatePicker, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useGetCommonList } from 'features/loading-log/use-cases/get-commonlist';
import { useGetRoleTypes } from 'features/users/use-cases/get-roleTypeList';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LoadingFilterFormField, LoadingFilterFormValues } from './type';
const { RangePicker } = DatePicker;


const { useBreakpoint } = Grid;

type VehicleFilterFormProps = {
  formId: string;
  handleFilter: (values: LoadingFilterFormValues) => void;
  initialValues: LoadingFilterFormValues;
  closeModal?: () => void;
  onRefresh: () => void;
};

export const LoadingFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
  onRefresh
}: VehicleFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<LoadingFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const { data: roleTypeFilterList, isLoading: roleTypeFilterLoading } = useGetRoleTypes();
  const onReset = () => {
    form.resetFields();
    handleFilter(initialValues);
    onRefresh();
  };
  const { data } = useGetCommonList({
    flag: "WeightType"
  } as any)
  const onFinish = (formValues: LoadingFilterFormValues) => {
    handleFilter(formValues);
    closeModal?.();
  };
  if (roleTypeFilterLoading) return null;

  if (!roleTypeFilterList || !Array.isArray(roleTypeFilterList) || roleTypeFilterList.length === 0) {
    return <div>No roles available</div>;
  }

  return (
    <Form<LoadingFilterFormValues>
      id={formId}
      name={formId}
      className='filters-form'
      form={form}
      layout='vertical'
      onFinish={onFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper className='cf_frm' style={{ width: '100%' }}>
        <StandardItemsWrapper className='cf_frm_row' style={{ width: '100%' }}>
          <div className='invoice_list' style={{ width: '100%' }}>
            <Form.Item<LoadingFilterFormValues>
              label={'Material Name	'}
              name={LoadingFilterFormField.MaterialName}
            >
              <Input
                placeholder={'Enter Material Name'}
              />
            </Form.Item>
            <Form.Item<LoadingFilterFormValues>
              label={'Driver Name	'}
              name={LoadingFilterFormField.DriverName}
            >
              <Input
                placeholder={'Enter Driver Name'}
              />
            </Form.Item>
            <Form.Item<LoadingFilterFormValues>
              label={'Vehicle Number'}
              name={LoadingFilterFormField.VehicleNumber}
            >
              <Input
                placeholder={'Enter Vehicle Name'}
              />
            </Form.Item>
            <Form.Item<LoadingFilterFormValues>
              label="Weight Type"
              name={LoadingFilterFormField.WeightType}
            >
              <Select
                placeholder="Please select"
                options={data?.res?.commonList.map((item: any) => ({
                    label: item?.title,
                    value: item?.id, // or use index if items are not unique
                  }))}
              />
            </Form.Item>
            <Form.Item<LoadingFilterFormValues>
              label={'Loading Date'}
              name={LoadingFilterFormField.Date}
            >
              <RangePicker />
            </Form.Item>
            {screens.lg && (
              <ContentFilters.ButtonsWrapper className='filter_btn'>
                <Button type='primary' htmlType='submit' >
                  {t('common.buttons.filter', { count: 1 })}
                </Button>
                <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
              </ContentFilters.ButtonsWrapper>
            )}
          </div>
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>


    </Form>
  );
};
